import { render, staticRenderFns } from "./gantt-redirect.vue?vue&type=template&id=3966af1a"
import script from "./gantt-redirect.vue?vue&type=script&lang=js"
export * from "./gantt-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports